import React from 'react';
import { Box, Typography, Card, CardContent,Grid } from '@mui/material';

import "../CSS/styles.css";


import { styled, createTheme, ThemeProvider } from '@mui/material/styles';

export default function JustDial() {

  const StyledGrid = styled(Grid)(({ theme }) => ({
    marginTop: theme.spacing(2.5),  // 20px margin top
    gap: theme.spacing(2.5)         // 20px column gap
  }));
  
  const StyledParagraph = styled('p')({
    textAlign: 'left'               // Left-align text
  });
  return (
<Box>
<StyledGrid container >
            <Grid container sx={{backgroundColor:'white'}}>
                <Grid item xs={12} md={6} lg={6} sx={{p:2}}>
                    <p>
                    <h2 style={{fontSize:'30px',fontWeight:'bolder'}}>Just Dial</h2>
                        <br /><br/>
                        <StyledParagraph>
                        <h6>We are a premier  taxi/cab  service in Salem , best cabs offering reliable and comfortable rides to all destinations.Our fleet of well-maintained vehicles and professional drivers ensure that you have a pleasant travel experience. Whether you need a ride to the airport, a business meeting, or a night out, we are here to provide you with the best service possible.</h6>
                        </StyledParagraph>
                    </p>
                </Grid>
                <Grid item xs={12} md={6} lg={6} sx={{p:2}}>
                <img
          src="/images/login/Dashboard/Assert/VisitingCard.webp"
          alt="Taxi Service"
          style={{width:'100%',height:'100%'}}
        />
               
                </Grid>
            </Grid>
</StyledGrid>
</Box>
  );
}